import React, { Component } from "react";

import ComponentHOC from "../hoc/ComponentHOC";
import Img from "react-image";
import { Link } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import ReactPlayer from "react-player";
//Component imports
import Videos from "../models/videos";
import facebookShare from "../img/icons/facebook-whitebg-icon.png";
//Images imports
import twitterShare from "../img/icons/twiter-whitebg-icon.png";

class ViewVideoComponent extends Component {
  constructor(props) {
    super(props);
    this.findProjectById = this.findProjectById.bind(this);
  }
  findProjectById(project) {
    var id = this.props.match.params.id;
    return project.vid_id === id;
  }
  render() {
    const { list } = this.props;
    const item = new Videos(list.find(this.findProjectById));
    return (
      <section className="view-entertainment-section black">
        <MetaTags>
          <title>Millennials Mafia - {item.title}</title>
          <meta name="description" content="Some description." />
          <meta
            property="og:title"
            content={`Millennials Mafia - ${item.title}`}
          />
          <meta property="og:image" content={item.src} />
        </MetaTags>
        <div className="container main-entertainment" style={{ width: "70%" }}>
          <div className="row">
            <div className="col-12 col-lg-12">
              <article>
                <span className="flag">
                  <Img src={item.flag} alt={item.title} />
                </span>
                <div className="entertainment-header center-view">
                  <h1 className="center-view">{item.title}</h1>
                  <div className="social">
                    <ul>
                      {item.twitterLink ? (
                        <li>
                          <Link to={item.twitterLink}>
                            <Img src={twitterShare} aria-hidden="true" />
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                      {item.facebookLink ? (
                        <li>
                          <Link to={item.facebookLink}>
                            <Img src={facebookShare} aria-hidden="true" />
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>

                <div className="view-video center-view">
                  <ReactPlayer
                    url={item.link}
                    controls
                    className="video-frame"
                  />
                </div>

                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ComponentHOC(ViewVideoComponent);



// WEBPACK FOOTER //
// ./src/components/view-video.js